import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from './auth/logged-in.guard';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { NotificationConfig } from './core/resources/notification.resource';
import { AtomService } from './core/atom.service';
import { UssdmenusConfig } from './core/resources/ussd-menu.ressource';
import { ShortcodesConfig } from './core/resources/shortcode.ressource';
import { KeywordsConfig } from './core/resources/keyword.ressource';
import { EnumsService } from './shared/services/enums.service';
import { AcquisitionAccountsConfig } from './core/resources/acquisition-account.resource';
import { AcquisitionMappingConfig } from './core/resources/acquisition-mapping.resource';
import { AcquisitionSourcesConfig } from './core/resources/acquisition-source.resource';
import { TrafficManagersConfig } from './core/resources/traffic-manager.resource';
import { CountryConfig } from './core/resources/country.resource';
import { BillingpoliciesConfig } from './core/resources/billing-policy';
import { CreditSetupConfig } from './core/resources/credit-setup.resource';
import { FirmsConfig } from './core/resources/firm.resource';
import { ContractConfig } from './core/resources/contract.resource';
import { MobileNetworkOperatorConfig } from './core/resources/mobile-network-operator.resource';
import { InternetServiceProviderConfig } from './core/resources/internet-service-provider.resource';
import { PaymentMethodsConfig } from './core/resources/payment-methods.resource';
import { JobsIpRangeConfig } from './core/resources/ip-range';
import { CatalogConfig } from './core/resources/catalog.resource';
import { TagConfig } from './core/resources/tag.resource';
import { FeeConfig } from './core/resources/fee.resource';
import { ServiceConfig } from './core/resources/service.resource';
import { ProductConfig } from './core/resources/product.resource';
import { SKUConfig } from './core/resources/sku.resource';
import { PlatformConfig } from './core/resources/platform.resource';
import { CappingConfig } from './core/resources/capping.resource';
import { OfferConfig } from './core/resources/offer.resource';
import {ActivityConfig } from './core/resources/activity.resource';
import { JobConfig } from './core/resources/job.resource';
import { BillingChannelConfig } from './core/resources/billing-channel.resource';
import { JobsIPRangesVersionsConfig } from './core/resources/jobsiprangesversions.resource';
import { VersionConfig } from './core/resources/version.resource';
import { EnumConfig } from './core/resources/enum.resource';
import { LegalDocumentConfig } from './core/resources/legal-document.resource';
import { LegalDocumentVersionConfig } from './core/resources/legal-document-version.resource';
import { LegalDocumentVersionArchiveConfig } from './core/resources/legal-document-version-archives.resource';
import { PackConfig } from './core/resources/pack.resource';
// import { DvpassComponent } from './dvpass/dvpass.component';

export class CONFIG {}
const routes: Routes = [
  { path: 'sign-in', component: SignInComponent },
  {
    path: '',
    component: HomeComponent,
    canActivate: [LoggedInGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          animation: 0,
          theme: 'default-theme',
          title: 'Dashboard',
        },
      },
      {
        path: 'countries',
        data: {
          animation: 1,
          theme: 'country-theme',
          title: 'Countries',
          config: CountryConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: CountryConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'firms',
        data: {
          animation: 1,
          theme: 'country-theme',
          title: 'Firms',
          config: FirmsConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: FirmsConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'mnos',
        data: {
          animation: 1,
          theme: 'country-theme',
          title: 'MNO',
          config: MobileNetworkOperatorConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: MobileNetworkOperatorConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'isps',
        data: {
          animation: 1,
          theme: 'country-theme',
          title: 'ISP',
          config: InternetServiceProviderConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: InternetServiceProviderConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'paymentmethods',
        data: {
          animation: 1,
          theme: 'country-theme',
          title: 'Payment Methods',
          config: PaymentMethodsConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: PaymentMethodsConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'jobsipranges',
        data: {
          animation: 1,
          theme: 'country-theme',
          title: 'IP Ranges',
          config: JobsIpRangeConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: JobsIpRangeConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'jobsiprangesversions',
        data: {
          animation: 1,
          theme: 'country-theme',
          title: 'IP Ranges Version',
          config: JobsIPRangesVersionsConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: JobsIPRangesVersionsConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'contracts',
        data: {
          animation: 1,
          theme: 'contract-theme',
          title: 'Contracts',
          config: ContractConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: ContractConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'catalogs',
        data: {
          animation: 1,
          theme: 'contract-theme',
          title: 'Catalogs',
          config: CatalogConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: CatalogConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'skus',
        data: {
          animation: 1,
          theme: 'contract-theme',
          title: 'SKU',
          config: SKUConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: SKUConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'cascades',
        data: {
          animation: 6,
          theme: 'contract-theme',
          title: 'Cascades',
        },
        loadChildren: () =>
          import('./cascades/cascades.module').then((m) => m.CascadesModule),
      },
      {
        path: 'fees',
        data: {
          animation: 7,
          theme: 'contract-theme',
          title: 'Fees',
          config: FeeConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: FeeConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'services',
        data: {
          animation: 8,
          theme: 'service-theme',
          title: 'Services',
          config: ServiceConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: ServiceConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'products',
        data: {
          animation: 8,
          theme: 'service-theme',
          title: 'Products',
          config: ProductConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: ProductConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'offers',
        data: {
          animation: 8,
          theme: 'service-theme',
          title: 'Offers',
          config: OfferConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: OfferConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      // {
      //   path: 'packs',
      //   data: {
      //     animation: 8,
      //     theme: 'service-theme',
      //     title: 'Packs',
      //     config: PackConfig,
      //   },
      //   providers: [
      //     {
      //       provide: CONFIG,
      //       useClass: PackConfig,
      //       deps: [AtomService],
      //     },
      //   ],
      //   loadChildren: () =>
      //     import('./resources/resources.module').then((m) => m.ResourcesModule),
      // },
      {
        path: 'packs',
        data: {
          animation: 11,
          theme: 'service-theme',
          title: 'Packs',
        },
        loadChildren: () =>
          import('./packs/packs.module').then((m) => m.PacksModule),
      },
      {
        path: 'creditsetups',
        data: {
          animation: 11,
          theme: 'service-theme',
          title: 'Credit setup',
          config: CreditSetupConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: CreditSetupConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'legaldocuments',
        data: {
          animation: 11,
          theme: 'service-theme',
          title: 'Legal Documents',
          config: LegalDocumentConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: LegalDocumentConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'legaldocumentversions',
        data: {
          animation: 11,
          theme: 'service-theme',
          title: 'Legal Document Versions',
          config: LegalDocumentVersionConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: LegalDocumentVersionConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'legaldocumentversionarchives',
        data: {
          animation: 11,
          theme: 'service-theme',
          title: 'Legal Document Version Archives',
          config: LegalDocumentVersionArchiveConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: LegalDocumentVersionArchiveConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'acquisitionaccounts',
        data: {
          config: AcquisitionAccountsConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: AcquisitionAccountsConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'acquisitionmappings',
        data: {
          config: AcquisitionMappingConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: AcquisitionMappingConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'acquisitionsources',
        data: {
          config: AcquisitionSourcesConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: AcquisitionSourcesConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'trafficmanagers',
        data: {
          config: TrafficManagersConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: TrafficManagersConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'billing-policies',
        data: {
          animation: 13,
          theme: 'service-theme',
          title: 'Billing policies',
          config: BillingpoliciesConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: BillingpoliciesConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'tags',
        data: {
          animation: 1,
          theme: 'service-theme',
          title: 'Tags',
          config: TagConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: TagConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'platforms',
        data: {
          animation: 15,
          theme: 'service-theme',
          title: 'Platforms',
          config: PlatformConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: PlatformConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'cappings',
        data: {
          animation: 15,
          theme: 'service-theme',
          title: 'Cappings',
          config: CappingConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: CappingConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'notifications',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Notifications',
          config: NotificationConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: NotificationConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'ussdmenus',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'USSD Menus',
          config: UssdmenusConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: UssdmenusConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'shortcodes',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Shortcodes',
          config: ShortcodesConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: ShortcodesConfig,
            deps: [AtomService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'keywords',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Keywords',
          config: KeywordsConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: KeywordsConfig,
            deps: [AtomService, EnumsService],
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'activities',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Activities',
          config: ActivityConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: ActivityConfig,
            deps: [AtomService]
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'jobs',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Jobs',
          config: JobConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: JobConfig,
            deps: [AtomService]
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'billingchannels',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Billing channels',
          config: BillingChannelConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: BillingChannelConfig,
            deps: [AtomService]
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },
      {
        path: 'versions',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Versions',
          config: VersionConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: VersionConfig,
            deps: [AtomService]
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },

      {
        path: 'enums',
        data: {
          animation: 17,
          theme: 'service-theme',
          title: 'Enums',
          config: EnumConfig,
        },
        providers: [
          {
            provide: CONFIG,
            useClass: EnumConfig,
            deps: [AtomService]
          },
        ],
        loadChildren: () =>
          import('./resources/resources.module').then((m) => m.ResourcesModule),
      },

    ],
  },
  // {
  //   path: 'dvpass',
  //   loadChildren: () =>
  //     import('./dvpass/dvpass.module').then((m) => m.DvpassModule),
  // },

  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
